// ==============================|| OVERRIDES - TABLE ||============================== //

export default function Table() {
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          minWidth: 'max-content'
        }
      }
    }
  };
}
